import React from 'react';
import { Helmet } from 'react-helmet-async';
import './style/About.css';

const About = () => {
  return (
    <div className="about">
      <Helmet>
        <title>Cosa facciamo | Studio TNPEE</title>
        <meta
          name="description"
          content="Scopri cosa facciamo presso lo Studio TNPEE. Interventi terapeutici per lo sviluppo psicomotorio dei bambini a Torino."
        />
        <meta
          property="og:title"
          content="Cosa facciamo | Studio TNPEE a Torino"
        />
        <meta
          property="og:description"
          content="Offriamo terapie neuropsicomotorie per bambini con professionalità e passione. Scopri i nostri servizi a Torino."
        />
        <meta property="og:type" content="website" />
        <meta
          property="og:url"
          content="https://www.studiovinzaglio24.com/cosa-facciamo"
        />
        {/* <meta
          property="og:image"
          content="https://www.studiovinzaglio24.com/assets/og-about.jpg"
        /> */}
        <link
          rel="canonical"
          href="https://www.studiovinzaglio24.com/cosa-facciamo"
        />
      </Helmet>

      <h2>Cosa facciamo</h2>
      <div className="image-container">
        <img
          src="/assets/poster-tnpee_page-0001.jpg"
          alt="Poster TNPEE"
          className="image-full-page"
        />
      </div>
    </div>
  );
};

export default About;
